import {
  getSupplierArticlesError,
  normalizeArticleKey,
} from '@/utils/nomenclature/articles'

export type AddSupplierArticleResult =
  | { articles: string[] }
  | { error: string }

export const addSupplierArticle = (
  articles: string[],
  draft: string
): AddSupplierArticleResult => {
  const article = draft.trim()
  if (!article) return { error: 'Введите артикул поставщика' }
  const key = normalizeArticleKey(article)
  if (articles.some((item) => normalizeArticleKey(item) === key)) {
    return { error: 'Такой артикул поставщика уже добавлен' }
  }
  const next = [...articles, article]
  const error = getSupplierArticlesError(next)
  return error ? { error } : { articles: next }
}
